export default __webpack_public_path__ + "static/media/background1.39fbb387.png";